import { render, staticRenderFns } from "./TrackersList.vue?vue&type=template&id=2fc29a8b&scoped=true&"
import script from "./TrackersList.vue?vue&type=script&setup=true&lang=js&"
export * from "./TrackersList.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc29a8b",
  null
  
)

export default component.exports